import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "font-weight-bold text-left" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-italic text-uppercase" }, "null", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "text-left"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_target_field = _resolveComponent("target-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_two_column = _resolveComponent("two-column", true)!
  const _component_from_now = _resolveComponent("from-now")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_ctx.deepLevel < _ctx.MAX_DEEP_LEVEL)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title != '')
          ? (_openBlock(), _createElementBlock("h2", {
              key: 0,
              class: _normalizeClass(["font-weight-black px-4 py-2 mt-4 text-decoration-underline text-center rounded-t-xl", _ctx.color])
            }, _toDisplayString(_ctx.title), 3))
          : _createCommentVNode("", true),
        _createVNode(_component_v_table, {
          dense: "",
          class: "grey lighten-2 rounded-b-xl mb-2 pa-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputData, (value, key, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  (_ctx.isVisibleItem(key))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", _hoisted_2, [
                          _createVNode(_component_target_field, {
                            target: _ctx.targets.find((t) => t.trigger_fields?.includes(key)),
                            onTargetClick: _ctx.targetClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.toCamelCase(key,true)), 1)
                            ]),
                            _: 2
                          }, 1032, ["target", "onTargetClick"])
                        ]),
                        (value === null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_3, _hoisted_5))
                          : (typeof value === 'object')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                                (_ctx.isArray(value) && value.length == 0)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 0,
                                      text: '(empty list)',
                                      type: "info",
                                      value: true
                                    }))
                                  : (_ctx.isArray(value))
                                    ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                        key: 1,
                                        "v-model": _ctx.expanded,
                                        title: key+' values'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel, {
                                            value: key,
                                            title: '(more...)'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [
                                                  ((typeof value[0] === 'object'))
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(value, (valueRow, idxRow) => {
                                                        return (_openBlock(), _createBlock(_component_two_column, {
                                                          key: 'array_'+idxRow,
                                                          inputData: valueRow,
                                                          isVisibleItem: _ctx.isVisibleItem,
                                                          deepLevel: _ctx.deepLevel+1
                                                        }, null, 8, ["inputData", "isVisibleItem", "deepLevel"]))
                                                      }), 128))
                                                    : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (valueRow, idxRow) => {
                                                          return (_openBlock(), _createElementBlock("li", { key: idxRow }, [
                                                            (_ctx.isValidDate(valueRow.toString()))
                                                              ? (_openBlock(), _createBlock(_component_from_now, {
                                                                  key: 'date-'+idxRow,
                                                                  date: valueRow
                                                                }, null, 8, ["date"]))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(valueRow), 1))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "title"])
                                        ]),
                                        _: 2
                                      }, 1032, ["v-model", "title"]))
                                    : (_openBlock(), _createBlock(_component_two_column, {
                                        key: 'object-'+index,
                                        inputData: value,
                                        title: "",
                                        isVisibleItem: _ctx.isVisibleItem,
                                        deepLevel: _ctx.deepLevel+1
                                      }, null, 8, ["inputData", "isVisibleItem", "deepLevel"]))
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_9, [
                                (_ctx.isValidDate(value.toString()))
                                  ? (_openBlock(), _createBlock(_component_from_now, {
                                      key: 'date-'+index,
                                      date: value
                                    }, null, 8, ["date"]))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 'other-'+index,
                                      innerHTML: value
                                    }, null, 8, _hoisted_10))
                              ]))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, "Too deep data! Tree is limited to " + _toDisplayString(_ctx.MAX_DEEP_LEVEL) + " levels", 1))
}